export enum Status {
  ACTIVE = 1,
  INACTIVE = 0
}
